<template >
  <div class="container-flight">


    <div ref="hoteldata" id="hoteldata">
      <div style="
        text-align: initial;
        margin-bottom: 15px;
        margin-top: 10px;
      ">
        <img width="200" height="50" src="../../../public/img/logo-pardis.png" alt="">
      </div>
      <div class="card">
        <div class="card-header">
          <span class="float-right">
            <i class="icon-flight-2"></i> <span>مشخصات پرواز</span>
          </span>
        </div>
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-md-12">
              <div>
                <div class="row">
                  <div class="col">
                    <span>
                      <img :src="
                        getLogoUrl(selectedFlight.departureFlight.airLineLogo)
                      " alt="Image" class="airline-logo" />{{ selectedFlight.departureFlight.airLineTitle }} - پرواز
                      رفت
                    </span>
                  </div>

                  <div class="flight-date"></div>
                </div>

                <div class="flight-detail row">
                  <div style="text-align: center" class="col">
                    <div>
                      {{ selectedFlight.departureFlight.originIATA }} -
                      {{ selectedFlight.departureFlight.departureTime }}
                    </div>
                    <div>
                      {{ selectedFlight.departureFlight.originCity }} -
                      {{ selectedFlight.departureFlight.origin }}
                    </div>
                  </div>
                  <div class="flight-number col">
                    <div>
                      پرواز {{ selectedFlight.departureFlight.flightNumber }}
                    </div>
                    <div class="flight-itinerary"></div>
                    <div>
                      {{
                          selectedFlight.departureFlight.departureDateTimeShamsiText
                      }}
                    </div>
                  </div>
                  <div style="text-align: center" class="col">
                    <div>
                      {{ selectedFlight.departureFlight.destinationIATA }} -
                      {{ selectedFlight.departureFlight.arrivalTime }}
                    </div>
                    <div>
                      {{ selectedFlight.departureFlight.destinationCity }} -
                      {{ selectedFlight.departureFlight.destination }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="table-responsive-sm">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th></th>

                  <th class="center">تعداد</th>
                  <th class="right">بهاء</th>
                  <th class="right">تخفیف</th>
                  <th class="right">جمع</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="selectedFlight.departureFlight.adultQty > 0">
                  <td class="left strong">بزرگسال</td>
                  <td class="left">
                    {{ selectedFlight.departureFlight.adultQty }}
                  </td>

                  <td class="right">
                    {{
                        selectedFlight.departureFlight.totalAdultProvideFare
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    {{
                        (selectedFlight.departureFlight.totalAdultProvideFare -
                          selectedFlight.departureFlight.totalAdultFare)
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    <strong>
                      {{
                          (selectedFlight.departureFlight.totalAdultFare *
                            selectedFlight.departureFlight.adultQty)
                          | numFormat
                          | rial
                      }}</strong>
                  </td>
                </tr>
                <tr v-if="selectedFlight.departureFlight.childQty > 0">
                  <td class="left strong">کودک</td>
                  <td class="left">
                    {{ selectedFlight.departureFlight.childQty }}
                  </td>

                  <td class="right">
                    {{
                        selectedFlight.departureFlight.totalChildProvideFare
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    {{
                        (selectedFlight.departureFlight.totalChildProvideFare -
                          selectedFlight.departureFlight.totalChildFare)
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    <strong>{{
                        (selectedFlight.departureFlight.totalChildFare *
                          selectedFlight.departureFlight.childQty)
                        | numFormat
                        | rial
                    }}</strong>
                  </td>
                </tr>
                <tr v-if="selectedFlight.departureFlight.infantQty">
                  <td class="left strong">نوزاد</td>
                  <td class="left">
                    {{ selectedFlight.departureFlight.infantQty }}
                  </td>

                  <td class="right">
                    {{
                        selectedFlight.departureFlight.totalInfantProvideFare
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    {{
                        (selectedFlight.departureFlight.totalInfantProvideFare -
                          selectedFlight.departureFlight.totalInfantFare)
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    <strong>{{
                        (selectedFlight.departureFlight.totalInfantFare *
                          selectedFlight.departureFlight.infantQty)
                        | numFormat
                        | rial
                    }}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-5"></div>

            <div class="col-lg-4 col-sm-5 ml-auto">
              <table class="table table-clear">
                <tbody>
                  <tr>
                    <td class="left">
                      <strong>جمع کل</strong>
                    </td>
                    <td class="right">
                      <strong style="font-size: 19px; color: #07557c">{{
                          (selectedFlight.departureFlight.totalChildFare *
                            selectedFlight.departureFlight.childQty +
                            selectedFlight.departureFlight.totalAdultFare *
                            selectedFlight.departureFlight.adultQty +
                            selectedFlight.departureFlight.totalInfantFare *
                            selectedFlight.departureFlight.infantQty)
                          | numFormat
                          | rial
                      }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->
        </div>

        <div class="card-body">
          <div class="row mb-4">
            <div class="col-md-12">
              <div>
                <div>
                  <div class="row">
                    <div class="col">
                      <span>
                        <img :src="
                          getLogoUrl(selectedFlight.returnFlight.airLineLogo)
                        " alt="Image" class="airline-logo" />{{ selectedFlight.returnFlight.airLineTitle }} - پرواز
                        برگشت
                      </span>
                    </div>
                  </div>

                  <div class="flight-detail row">
                    <div style="text-align: center" class="col">
                      <div>
                        {{ selectedFlight.returnFlight.originIATA }} -
                        {{ selectedFlight.returnFlight.departureTime }}
                      </div>
                      <div>
                        {{ selectedFlight.returnFlight.originCity }} -
                        {{ selectedFlight.returnFlight.origin }}
                      </div>
                    </div>
                    <div class="flight-number col">
                      <div>
                        پرواز {{ selectedFlight.returnFlight.flightNumber }}
                      </div>
                      <div class="flight-itinerary"></div>
                      <div class="flight-date">
                        <span>{{
                            selectedFlight.returnFlight.departureDateTimeShamsiText
                        }}</span>
                      </div>
                    </div>
                    <div style="text-align: center" class="col">
                      <div>
                        {{ selectedFlight.returnFlight.destinationIATA }} -
                        {{ selectedFlight.returnFlight.arrivalTime }}
                      </div>
                      <div>
                        {{ selectedFlight.returnFlight.destinationCity }} -
                        {{ selectedFlight.returnFlight.destination }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="table-responsive-sm">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th></th>

                  <th class="center">تعداد</th>
                  <th class="right">بهاء</th>
                  <th class="right">تخفیف</th>
                  <th class="right">جمع</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="selectedFlight.returnFlight.adultQty > 0">
                  <td class="left strong">بزرگسال</td>
                  <td class="left">
                    {{ selectedFlight.returnFlight.adultQty }}
                  </td>

                  <td class="right">
                    {{
                        selectedFlight.returnFlight.totalAdultProvideFare
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    {{
                        (selectedFlight.returnFlight.totalAdultProvideFare -
                          selectedFlight.returnFlight.totalAdultFare)
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    <strong>
                      {{
                          (selectedFlight.returnFlight.totalAdultFare *
                            selectedFlight.returnFlight.adultQty)
                          | numFormat
                          | rial
                      }}</strong>
                  </td>
                </tr>
                <tr v-if="selectedFlight.returnFlight.childQty > 0">
                  <td class="left strong">کودک</td>
                  <td class="left">
                    {{ selectedFlight.returnFlight.childQty }}
                  </td>

                  <td class="right">
                    {{
                        selectedFlight.returnFlight.totalChildProvideFare
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    {{
                        (selectedFlight.returnFlight.totalChildProvideFare -
                          selectedFlight.returnFlight.totalChildFare)
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    <strong>{{
                        (selectedFlight.returnFlight.totalChildFare *
                          selectedFlight.returnFlight.childQty)
                        | numFormat
                        | rial
                    }}</strong>
                  </td>
                </tr>
                <tr v-if="selectedFlight.returnFlight.infantQty">
                  <td class="left strong">نوزاد</td>
                  <td class="left">
                    {{ selectedFlight.returnFlight.infantQty }}
                  </td>

                  <td class="right">
                    {{
                        selectedFlight.returnFlight.totalInfantProvideFare
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    {{
                        (selectedFlight.returnFlight.totalInfantProvideFare -
                          selectedFlight.returnFlight.totalInfantFare)
                        | numFormat
                        | rial
                    }}
                  </td>
                  <td class="right">
                    <strong>{{
                        (selectedFlight.returnFlight.totalInfantFare *
                          selectedFlight.returnFlight.infantQty)
                        | numFormat
                        | rial
                    }}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-5"></div>

            <div class="col-lg-4 col-sm-5 ml-auto">
              <table class="table table-clear">
                <tbody>
                  <tr>
                    <td class="left">
                      <strong>جمع کل</strong>
                    </td>
                    <td class="right">
                      <strong style="font-size: 19px; color: #07557c">{{
                          (selectedFlight.returnFlight.totalChildFare *
                            selectedFlight.returnFlight.childQty +
                            selectedFlight.returnFlight.totalAdultFare *
                            selectedFlight.returnFlight.adultQty +
                            selectedFlight.returnFlight.totalInfantFare *
                            selectedFlight.returnFlight.infantQty)
                          | numFormat
                          | rial
                      }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <span class="float-right">
            <i class="icon-star"></i> <span>مشخصات اقامت</span>
          </span>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <strong style="justify-content: center">{{ selectedRoom[0].hotelName }}</strong>
            </div>
            <br></br>
            <div class="col-4">
              <p> از تاریخ :
                {{ fromDate }}
              </p>

            </div>
            <div class="col-4">

              <p>تا تاریخ :
                {{ toDate }}
              </p>
            </div>
            <div class="col-4">

              <p>مدت اقامت :
                {{ totalNight }} شب
              </p>
            </div>
          </div>

          <!-- <div class="col-12" style="justify-content: center">

            <div class="table-responsive-sm" style="text-align: right;">
              <table class="table table-striped">
                <thead>
                  <tr>

                    <th class="right">نوع اتاق</th>
                    <th class="right">مبلغ اتاق</th>
                    <th class="right"> تخفیف</th>
                    <th class="right">جمع </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(room, index) in selectedRoom" :key="index">

                    <td class="right">
                      {{ room.name }}
                    </td>

                    <td class="right">
                      {{ room.totalBasePrice | numFormat | rial }}
                    </td>
                    <td class="right">
                      {{ room.totalBasePrice - room.totalFarePrice | numFormat | rial }}
                    </td>
                    <td class="right">
                      {{ room.totalFarePrice | numFormat | rial }}
                    </td>

                  </tr>

                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-5"></div>

              <div class="col-lg-4 col-sm-5 ml-auto">
                <table class="table table-clear">
                  <tbody>
                    <tr>
                      <td class="left">
                        <strong>جمع کل</strong>
                      </td>
                      <td class="right">
                        <strong style="font-size: 19px; color: #07557c">
                          {{ sumOfRoomPrice * totalNight | numFormat | rial }}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <br>
          <div class="col-lg-4 col-sm-5 ml-auto">
            <table class="table table-clear">
              <tbody>
                <tr>
                  <td class="">
                    <strong>جمع قابل پرداخت</strong>

                  </td>
                  <td class="right">
                    <strong style="font-size: 19px; color: #07557c">
                  <td class="right">
                    <strong style="font-size: 19px; color: #07557c">
                      {{ (sumOfRoomPrice * totalNight) + (selectedFlight.departureFlight.totalChildFare *
                          selectedFlight.departureFlight.childQty +
                          selectedFlight.departureFlight.totalAdultFare *
                          selectedFlight.departureFlight.adultQty +
                          selectedFlight.departureFlight.totalInfantFare *
                          selectedFlight.departureFlight.infantQty) +
                          (selectedFlight.returnFlight.totalChildFare *
                            selectedFlight.returnFlight.childQty +
                            selectedFlight.returnFlight.totalAdultFare *
                            selectedFlight.returnFlight.adultQty +
                            selectedFlight.returnFlight.totalInfantFare *
                            selectedFlight.returnFlight.infantQty) | numFormat | rial
                      }}
                    </strong>
                  </td>
                  </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>
      </div>
    </div>
    <div class="col-12">
      <button style="width: 150px;" type="submit" class="btn btn-primary" @click="toPDF">دانلود فایل</button>
    </div>

  </div>
</template>

<script>
import Store from "../../views/tour/store/index";
import moment from "moment";
import date from "../../utils/date";
import exportFiles from "../../utils/exportFiles";
export default {
  name: "HotelSearch",
  components: {},
  store: Store,
  props: {
    bookingDetail: {},
  },
  data() {
    return {
      selectedFlight: {},
      totalNight: 0,
      params: {},
      selectedRoom: "",
      fromDate: "",
      toDate: "",
    };
  },

  computed: {
    sumOfRoomPrice() {
      var total = 0;
      this.selectedRoom.forEach(element => {
        total = total + element.totalFarePrice;
      });
      return total;
    },
    filteredRooms() {
      console.log('this.roomCount(this.selectedRoom)', this.roomCount(this.selectedRoom))
      return this.roomCount(this.selectedRoom);
    },
  },
  async created() {
    this.params = this.$route.query;
    this.selectedFlight = this.bookingDetail.selectedFlight;
    this.selectedRoom = this.bookingDetail.selectedRoom;
    this.calculateTotalNight();
    console.log("this.bookingDetailbookingDetailbookingDetail", this.bookingDetail);
  },
  mounted() { },
  methods: {
    toPDF() {
      var fileName = 'PDK_hotel'
      exportFiles.ExportToPDF(this.$refs.hoteldata, fileName, null, null);

    },
    getLogoUrl(name) {
      return "../img/airlines/" + name + ".png";
    },

    roomCount(array) {
      let counts = array.reduce(
        (out, { name }) => ({ ...out, [name]: out[name] + 1 || 1 }),
        {}
      );

      debugger;
      return Object.keys(counts).map((key) => ({

        name: key,
        count: counts[key],
      }));
    },
    calcRoomTotalPrice: function (rooms) {
      return rooms.reduce((acc, val) => {
        return acc + parseInt(val.totalFarePrice);
      }, 0);
    },

    calculateTotalNight() {
      let fDate = this.params.fromDate;
      let tDate = this.params.toDate;
      this.fromDate = date.ConvertToPersian(fDate);
      this.toDate = date.ConvertToPersian(tDate)
      this.totalNight = 0;
      if (
        fDate != "" &&
        fDate != null &&
        tDate != "" &&
        tDate != null
      ) {

        var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

        let diff = Math.round(duration.asDays());

        this.totalNight = diff;
      } else {
        this.totalNight = 0;
      }
    },
  },
};
</script>

<style scoped>

.flight-number {
  text-align: center;
}

.flight-itinerary {
  position: relative;
  width: 100%;
  border: 1px solid #14012a;
  height: 1px;
  display: flex;
  justify-content: space-evenly;
  margin-top: 10px;
}

.flight-itinerary::before {
  width: 7px;
  height: 7px;
  background: #14012a;
  content: "";
  position: absolute;
  border-radius: 50%;
  right: -4px;
  top: -3px;
}

.flight-itinerary::after {
  width: 7px;
  height: 7px;
  background: #14012a;
  content: "";
  position: absolute;
  border-radius: 50%;
  left: -4px;
  top: -3px;
}

.itinerary-box {
  min-height: 278px;
  padding: 20px;
  position: relative;
  background: #fff;
  margin-bottom: 30px;
  color: #333;
    box-shadow: 0 0 15px 0 rgba(0,0,0,0.1);
    border-radius: 15px;
}

.airline-logo {
  position: relative !important;
  left: 0% !important;
  width: 32px;
  margin-top: -8px;
}

.flight-date {
  margin-left: 15px;
}

.flight-detail {
  padding-top: 15px;
  padding-right: 30px;
  padding-left: 30px;
}

.airline-title {
  margin-right: 10px !important;
  margin-top: 4px !important;
}
</style>



